import React, { useState } from "react";
import { toast } from "sonner";
import { UserPen } from "lucide-react";
import api from "../api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

const FIELDS = [
  ["name", "Nome", "text"], ["email", "Email", "email"], ["phone", "Telefone / WhatsApp", "tel"],
  ["birthday", "Aniversário", "date"], ["cpf", "CPF", "text"],
];

export const EditProfileDialog = ({ user, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const isGoogle = !user.has_password;

  const openDlg = () => { setForm(Object.fromEntries(FIELDS.map(([k]) => [k, user[k] || ""]))); setOpen(true); };
  const save = async () => {
    if (!form.name?.trim()) return toast.error("Informe seu nome");
    setSaving(true);
    try {
      const body = Object.fromEntries(Object.entries(form).filter(([k, v]) => v !== (user[k] || "")));
      if (Object.keys(body).length) await api.patch("/auth/me", body);
      toast.success("Perfil atualizado"); setOpen(false); onSaved();
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Não foi possível salvar"); }
    finally { setSaving(false); }
  };

  return (
    <>
      <button onClick={openDlg} className="btn-ghost !py-1.5 !px-3 text-xs inline-flex items-center gap-1 mt-2" data-testid="btn-edit-profile"><UserPen size={12}/> Editar perfil</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="edit-profile-dialog">
          <DialogHeader><DialogTitle className="font-serif text-2xl">Editar perfil</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {FIELDS.map(([k, label, type]) => (
              <label key={k} className="block">
                <span className="text-[10px] tracking-widest text-[color:var(--sun-700)] font-display">{label.toUpperCase()}</span>
                <input type={type} value={form[k] || ""} onChange={e => setForm({ ...form, [k]: e.target.value })}
                       disabled={k === "email" && isGoogle}
                       className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm disabled:opacity-60" data-testid={`profile-input-${k}`}/>
                {k === "email" && isGoogle && <span className="text-[10px] text-[color:var(--ink-500)]">Conta Google: o email é o da sua conta Google.</span>}
              </label>
            ))}
          </div>
          <DialogFooter>
            <button onClick={save} disabled={saving} className="btn-gold" data-testid="btn-save-profile">{saving ? "Salvando..." : "Salvar"}</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
